import { useCallback } from 'react';

import { OasMemoryError, OasError } from 'core/atoms/errors';

import { gql, useMutation } from 'core/dna/types/apollo';
import { SubstituteTeacherState } from 'core/dna/types/generated/_globalTypes';
import {
  ActivateSubstituteTeacher,
  ActivateSubstituteTeacherVariables,
} from 'core/dna/types/generated/ActivateSubstituteTeacher';

import { GET_SUBSTITUTE_TEACHERS_QUERY } from '../get-substitute-teachers';

export const ACTIVATE_SUBSTITUTE_TEACHER_MUTATION = gql`
  mutation ActivateSubstituteTeacher($input: UpdateSubstituteTeacherInput!) {
    updateSubstituteTeacher(input: $input) {
      id
    }
  }
`;

const TITLE = 'use-activate-substitute-teacher';

export const useActivateSubstituteTeacher = () => {
  const [activateSubstituteTeacher] = useMutation<
    ActivateSubstituteTeacher,
    ActivateSubstituteTeacherVariables
  >(ACTIVATE_SUBSTITUTE_TEACHER_MUTATION);

  const func = useCallback(
    async (
      id: string,
      firstName: string,
      lastName: string,
      phone?: string,
      email?: string,
      tags?: string,
    ) => {
      try {
        const result = await activateSubstituteTeacher({
          variables: {
            input: {
              substituteTeacherId: id,
              firstName,
              lastName,
              mail: email,
              msisdn: phone,
              tags: tags?.split(','),
              state: SubstituteTeacherState.active,
            },
          },
          refetchQueries: [
            {
              query: GET_SUBSTITUTE_TEACHERS_QUERY,
            },
          ],
        });

        if (result.errors) {
          throw new OasMemoryError(JSON.stringify(result.errors), {
            title: TITLE,
          });
        }
        return result.data?.updateSubstituteTeacher ?? undefined;
      } catch (e) {
        if (e instanceof OasError) {
          throw e;
        } else {
          throw OasMemoryError.fromError(e, {
            title: TITLE,
          });
        }
      }
    },
    [activateSubstituteTeacher],
  );

  return {
    activateSubstituteTeacher: func,
  };
};
